import apiClient from "utils/apiClient";
import { PAYMENT_SERVICE_BASE_URL, ACTOR_ID_HEADER_KEY } from "constants";
import { v4 as uuid } from "uuid";

const API_BASE = `${PAYMENT_SERVICE_BASE_URL}/api/v1`;

const unwrap = (response) => response.data;

const withPaging = (params = {}) => {
  const { page = 0, size = 20, ...rest } = params;
  return { page, size, ...rest };
};

const mutationHeaders = (actorId) => ({
  [ACTOR_ID_HEADER_KEY]: actorId,
  "O-CORRELATION-ID": uuid(),
});

export const identitySubscriptionService = {
  plans: {
    list: async (params = {}) =>
      apiClient
        .get(`${API_BASE}/subscription-plans`, { params: withPaging(params) })
        .then(unwrap),

    get: async (planId, params = {}) =>
      apiClient
        .get(`${API_BASE}/subscription-plans/${planId}`, { params })
        .then(unwrap),

    getByCode: async (code) =>
      apiClient.get(`${API_BASE}/subscription-plans/code/${code}`).then(unwrap),

    create: async (data) =>
      apiClient.post(`${API_BASE}/subscription-plans`, data).then(unwrap),

    update: async (planId, data) =>
      apiClient.patch(`${API_BASE}/subscription-plans/${planId}`, data).then(unwrap),

    delete: async (planId) =>
      apiClient.delete(`${API_BASE}/subscription-plans/${planId}`).then(unwrap),
  },

  subscriptions: {
    list: async (params = {}) =>
      apiClient
        .get(`${API_BASE}/subscriptions`, { params: withPaging(params) })
        .then(unwrap),

    get: async (subscriptionId, params = {}) =>
      apiClient
        .get(`${API_BASE}/subscriptions/${subscriptionId}`, { params })
        .then(unwrap),

    listByPlan: async (planId, params = {}) =>
      apiClient
        .get(`${API_BASE}/subscriptions/plan/${planId}`, { params: withPaging(params) })
        .then(unwrap),

    create: async (data, actorId = "") =>
      apiClient
        .post(`${API_BASE}/subscriptions`, data, {
          headers: mutationHeaders(actorId),
        })
        .then(unwrap),

    update: async (subscriptionId, data, actorId = "") =>
      apiClient
        .patch(`${API_BASE}/subscriptions/${subscriptionId}`, data, {
          headers: mutationHeaders(actorId),
        })
        .then(unwrap),

    cancel: async (subscriptionId, actorId = "", cancellationReason = "") =>
      apiClient
        .post(
          `${API_BASE}/subscriptions/${subscriptionId}/cancel`,
          cancellationReason ? { cancellationReason } : undefined,
          {
            headers: mutationHeaders(actorId),
          },
        )
        .then(unwrap),
  },
};

export default identitySubscriptionService;
